var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullstory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1125 l0 -1125 1125 0 1125 0 0 1125 0 1125 -1125 0 -1125 0 0 -1125z m1123 414 c37 -10 37 -10 37 -64 0 -54 0 -54 -26 -45 -36 14 -87 12 -109 -4 -16 -11 -20 -30 -23 -90 l-4 -76 63 0 62 0 -21 -22 c-11 -13 -25 -35 -31 -50 -8 -22 -17 -28 -41 -28 l-30 0 0 -205 0 -205 -55 0 -55 0 0 205 0 205 -40 0 -40 0 0 50 0 50 40 0 40 0 0 78 c0 103 26 157 90 190 49 24 85 27 143 11z m247 -285 c40 -16 40 -16 40 -70 0 -30 -2 -54 -5 -54 -2 0 -19 9 -37 20 -70 42 -162 34 -174 -15 -9 -38 17 -60 99 -85 90 -28 132 -67 142 -133 10 -68 -21 -128 -81 -158 -39 -18 -57 -21 -127 -17 -45 3 -94 11 -109 18 -26 12 -28 18 -28 67 0 30 3 53 8 51 127 -66 222 -61 222 12 0 36 -22 51 -103 74 -36 10 -72 30 -94 50 -31 28 -37 40 -40 87 -8 108 56 169 179 169 39 0 85 -7 108 -16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullstory);
export default __webpack_public_path__ + "static/media/fullstory.a0fb7718f799a8dc82b22cb3ab821d02.svg";
export { ForwardRef as ReactComponent };